import { Link } from "react-router-dom";
import { todayUpdates } from "@/mocks/comics";

export default function UpdatesSection() {
  return (
    <section className="bg-background-50 py-12 md:py-16">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-end justify-between gap-4">
          <div>
            <span className="inline-flex items-center gap-1.5 text-xs font-medium text-primary-600 bg-primary-100 px-3 py-1 rounded-full">
              <i className="ri-time-line"></i>今日更新
            </span>
            <h2 className="mt-3 font-heading text-2xl md:text-4xl text-foreground-950">最新话抢先看</h2>
            <p className="mt-2 text-sm md:text-base text-foreground-500">每日更新的热门连载，第一时间掌握剧情进展。</p>
          </div>
          <Link
            to="/latest"
            className="hidden sm:inline-flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 whitespace-nowrap"
          >
            查看全部 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="mt-8 flex gap-4 overflow-x-auto no-scrollbar pb-2 -mx-4 px-4 md:-mx-6 md:px-6">
          {todayUpdates.map((item) => (
            <Link
              key={item.id}
              to={`/comic/${item.comicId}`}
              className="group w-[150px] md:w-[168px] shrink-0"
            >
              <div className="relative rounded-2xl overflow-hidden aspect-[3/4] bg-background-100">
                <img
                  src={item.cover}
                  alt={`${item.title} ${item.chapter} 最新话更新`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
                />
                <span className="absolute top-2 left-2 flex items-center gap-1 bg-primary-500 text-background-50 text-[10px] font-medium px-2 py-0.5 rounded-md">
                  <i className="ri-flashlight-fill text-xs"></i>NEW
                </span>
                <span className="absolute bottom-2 right-2 text-[10px] text-background-100 bg-black/50 px-1.5 py-0.5 rounded-md">
                  {item.time}
                </span>
              </div>
              <h3 className="mt-2.5 text-sm font-medium text-foreground-900 truncate">{item.title}</h3>
              <p className="mt-0.5 text-xs text-foreground-500 truncate group-hover:text-primary-600 transition-colors">
                {item.chapter}
              </p>
            </Link>
          ))}
        </div>

        <Link
          to="/latest"
          className="sm:hidden mt-5 inline-flex items-center gap-1 text-sm text-primary-600 whitespace-nowrap"
        >
          查看全部今日更新 <i className="ri-arrow-right-line"></i>
        </Link>
      </div>
    </section>
  );
}